// OCR Configuration
export const OCR_CONFIG = {
  TESSERACT_OPTIONS: {
    logger: true,
    errorHandler: true,
  },
  WORKER_PARAMS: {
    tessedit_char_whitelist: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789 .-/()+',
    tessedit_pageseg_mode: '6', // Uniform block of text
  }
};

// File Upload Constraints
export const FILE_CONSTRAINTS = {
  MAX_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
  MIME_TYPE_PREFIX: 'image/',
};

// NRIC Patterns (Myanmar)
export const NRIC_PATTERNS = {
  // Myanmar NRIC format: 12/MaGaDa(N)123456 (flexible for OCR)
  NRIC_NUMBER: /(\d{1,2})\s*\/\s*([A-Za-z]{3,8})\s*\(\s*(?:N|NAING)\s*\)\s*(\d{6})/i,
  NRIC_FLEXIBLE: /(\d{1,2})\s*[\/\\]\s*([A-Za-z]{3,8})\s*[\(\[]?\s*(?:N|NAING)\s*[\)\]]?\s*(\d{6})/i,
  NRIC_VERY_FLEXIBLE: /(\d{1,2})\s*[\/\\|]\s*([A-Za-z]{2,10})\s*[\(\[]?\s*(?:N|NAING|n|naing)\s*[\)\]]?\s*(\d{5,7})/i,
  
  // Myanmar phone patterns
  PHONE_NUMBER: /^(?:\+?95|0)?[1-9]\d{7,9}$/,
  MOBILE_PHONE: /^(?:\+?95|0)?9[0-9]{8}$/,
  LANDLINE_PHONE: /^(?:\+?95|0)?[1-8]\d{6,8}$/,
  
  // Alternative phone pattern for OCR (may have spaces or formatting issues)
  PHONE_OCR_FLEXIBLE: /(?:\+?95\s?|0)?\s?[1-9]\s?\d{1,3}\s?\d{2,3}\s?\d{3,4}/,
  
  NAME_KEYWORDS: ['name', 'nama', 'full name', 'given name', 'အမည်'],
  PHONE_KEYWORDS: ['phone', 'tel', 'mobile', 'contact', 'ဖုန်း'],
  NRIC_KEYWORDS: ['nric', 'ic', 'identity card', 'identification', 'နိုင်ငံသားစီစစ်ရေးကတ်'],
};

// Processing Stages
export const PROCESSING_STAGES = {
  IDLE: 'idle',
  LOADING: 'loading',
  RECOGNIZING: 'recognizing',
  PARSING: 'parsing',
  COMPLETE: 'complete',
  ERROR: 'error',
} as const;

// Progress Percentages
export const PROGRESS_STAGES = {
  LOADING: 10,
  RECOGNIZING_START: 20,
  RECOGNIZING_END: 80,
  PARSING: 85,
  COMPLETE: 100,
};

// UI Constants
export const UI_CONSTANTS = {
  CONFIDENCE_THRESHOLDS: {
    HIGH: 80,
    MEDIUM: 60,
  },
  ANIMATION_DELAYS: {
    STAGE_TRANSITION: 500,
    COMPLETION_DISPLAY: 2000,
  },
  COLORS: {
    PRIMARY: '#3b82f6',
    SUCCESS: '#10b981',
    WARNING: '#f59e0b',
    ERROR: '#ef4444',
  },
};

// Error Messages
export const ERROR_MESSAGES = {
  OCR_INIT_FAILED: 'Failed to initialize OCR engine. Please refresh and try again.',
  IMAGE_PROCESSING_FAILED: 'Failed to process the image. Please try with a clearer image.',
  NO_NRIC_DATA: 'Could not extract NRIC data from the image. Please ensure the image contains clear NRIC information.',
  FILE_TOO_LARGE: 'Image file is too large. Please select a file smaller than 10MB.',
  INVALID_FILE_TYPE: 'Please select a valid image file (JPG, PNG, GIF).',
  GENERIC_ERROR: 'An unexpected error occurred. Please try again.',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  PROCESSING_COMPLETE: 'Processing completed successfully!',
  DATA_EXTRACTED: 'NRIC data extracted successfully!',
  FILE_UPLOADED: 'Image uploaded successfully!',
};

